<template>
  <div
    v-bind="$attrs"
    class="container flex-between flex-stretch gap-max margin-auto-horizontal">
    <div
      class="form-wrapper padding-max-vertical"
      style="flex: 0 2 clamp(400px, 100%, 700px)">
      <slot></slot>
    </div>
    <aside
      :class="asideClass" :style="{ width: asideWidth }">
      <slot name="sidebar" v-bind="{ sidebarClass, addSidebarClass, removeSidebarClass }"></slot>
    </aside>
  </div>
</template>

<script>
export default {
  props: {
    sidebarPosition: {
      type: String,
      default: "inline-end"
    }
  },
  data: function () {
    return {
      asideClass:
        "aside l:visible box-shadow-2 overflow-y-visible overflow-x-hidden bg-gray-1 padding-max-vertical padding-l-horizontal flex-column flex-start flex-center",
      asideWidth: "350px",
    };
  },
  computed: {
    sidebarClass: {
      get() {
        return this.asideClass;
      },
      set(val) {
        this.asideClass = val;
      },
    },
  },
  methods: {
    addSidebarClass(val) {
      let split = this.asideClass.split(" ");
      if (!split.includes(val)) {
        split.push(val);
      }

      this.asideClass = split.join(" ");
    },
    removeSidebarClass(val) {
      let split = this.asideClass.split(" ");
      if (!split.includes(val)) {
        return false;
      }

      split = split.filter((className) => className !== val);
      this.asideClass = split.join(" ");
      return true;
    },
  },
};
</script>

<style scoped lang="scss"></style>
